<div class="attribute-box" [ngbTooltip]="tooltip()">
    <span class="attribute-label">{{ name() }}</span>
    <span>|&nbsp;</span>
    <span class="attribute-key">{{ value() }}</span>
</div>
